export interface CityData {
  name: string;
  lat: number;
  lng: number;
}

export interface LocationData {
  slug: string;
  name: string;
  state: string;
  region: string;
  description: string;
  highlights: string[];
  content: string[];
  isPrimary: boolean;
  lat: number;
  lng: number;
  cities: CityData[];
}

export const locations: LocationData[] = [
  {
    slug: "deltona",
    name: "Deltona",
    state: "FL",
    region: "Volusia County",
    isPrimary: true,
    lat: 28.9005,
    lng: -81.2637,
    description:
      "Deltona is our home base. Villalobos Prime Services LLC provides painting, flooring, drywall, and remodeling services to homeowners across Deltona and the surrounding Volusia County communities.",
    highlights: [
      "Locally based Deltona team",
      "Fast scheduling and free estimates",
      "Painting, flooring, drywall & remodeling",
      "10% discount for new clients",
    ],
    content: [
      "Villalobos Prime Services LLC is proudly based in Deltona, Florida. From Deltona Lakes to Saxon Boulevard, we help homeowners keep their properties looking sharp with interior and exterior painting, tile and vinyl flooring, drywall repair, cabinet restoration, and bathroom remodeling — all delivered with quality work, honest service, and lasting results.",
      "Because we live and work here, we understand what Central Florida homes go through: intense sun that fades exterior paint, humidity that stresses drywall, and busy family life that wears on floors and cabinets. We recommend materials and finishes that hold up to real Florida conditions.",
      "Every project in Deltona starts with a free, no-pressure estimate, and new clients receive 10% off their first project. Call (786) 306-5704 to get started.",
    ],
    cities: [
      { name: "Orange City", lat: 28.9489, lng: -81.2987 },
      { name: "Sanford", lat: 28.8003, lng: -81.2731 },
      { name: "DeLand", lat: 29.0283, lng: -81.3031 },
      { name: "Daytona Beach", lat: 29.2108, lng: -81.0228 },
      { name: "Port Orange", lat: 29.1383, lng: -80.9956 },
      { name: "Altamonte Springs", lat: 28.6611, lng: -81.3656 },
      { name: "Winter Park", lat: 28.6, lng: -81.3392 },
      { name: "Oviedo", lat: 28.67, lng: -81.2081 },
    ],
  },
  {
    slug: "orange-city",
    name: "Orange City",
    state: "FL",
    region: "Volusia County",
    isPrimary: false,
    lat: 28.9489,
    lng: -81.2987,
    description:
      "Professional painting, flooring, drywall, and remodeling services for Orange City homeowners — just minutes from our Deltona home base.",
    highlights: [
      "Minutes from our Deltona base",
      "Interior & exterior painting",
      "Tile, vinyl & drywall work",
      "Free, no-pressure estimates",
    ],
    content: [
      "Orange City is one of the closest communities to our Deltona headquarters, which means fast response times and flexible scheduling for everything from a single-room repaint to a full bathroom remodel.",
      "We help Orange City homeowners with interior and exterior painting, ceramic tile and vinyl plank flooring, drywall repair, cabinet painting and installation, and the finish work that completes a remodel properly.",
      "Request your free estimate today — new clients in Orange City receive 10% off their first project with Villalobos Prime Services LLC.",
    ],
    cities: [
      { name: "Blue Spring Area", lat: 28.947, lng: -81.339 },
      { name: "West Highlands", lat: 28.957, lng: -81.312 },
      { name: "Saxon Ridge", lat: 28.936, lng: -81.286 },
      { name: "DeBary", lat: 28.883, lng: -81.308 },
    ],
  },
  {
    slug: "sanford",
    name: "Sanford",
    state: "FL",
    region: "Seminole County",
    isPrimary: false,
    lat: 28.8003,
    lng: -81.2731,
    description:
      "Quality painting, remodeling, and repair services for Sanford homes — from historic downtown to the newer communities along Lake Monroe.",
    highlights: [
      "Serving all of Sanford",
      "Careful work in historic homes",
      "Painting, flooring & remodeling",
      "10% new client discount",
    ],
    content: [
      "Sanford's mix of historic homes and newer construction calls for a contractor who adapts. Whether it's fresh paint and drywall repair in an older downtown home or new vinyl plank flooring in a newer build, we bring the same disciplined prep and clean finish work to every project.",
      "Our Sanford services include interior and exterior painting, tile and vinyl floor installation, bathroom remodeling, cabinet restoration and installation, and drywall repair.",
      "We're just across the St. Johns River from our Deltona base — call (786) 306-5704 for a free estimate anywhere in Sanford.",
    ],
    cities: [
      { name: "Historic Downtown", lat: 28.812, lng: -81.268 },
      { name: "Lake Mary", lat: 28.759, lng: -81.318 },
      { name: "Midway", lat: 28.795, lng: -81.226 },
      { name: "Heathrow", lat: 28.763, lng: -81.372 },
    ],
  },
  {
    slug: "deland",
    name: "DeLand",
    state: "FL",
    region: "Volusia County",
    isPrimary: false,
    lat: 29.0283,
    lng: -81.3031,
    description:
      "Painting, flooring, drywall, and remodeling services for DeLand homeowners — honest service and lasting results from a local Volusia County team.",
    highlights: [
      "Local Volusia County crew",
      "Interior & exterior painting",
      "Bathroom & cabinet projects",
      "Free written estimates",
    ],
    content: [
      "From the historic neighborhoods near Stetson University to the growing communities on the edges of town, DeLand homeowners trust Villalobos Prime Services for careful, detail-driven work.",
      "We handle interior and exterior painting, ceramic tile and luxury vinyl flooring, drywall repair and texture matching, kitchen cabinet painting and new cabinet installation, and bathroom remodels — finished cleanly down to the last detail.",
      "Every DeLand project begins with a free estimate and clear scope. New clients save 10% on their first project.",
    ],
    cities: [
      { name: "Downtown DeLand", lat: 29.028, lng: -81.301 },
      { name: "Glenwood", lat: 29.065, lng: -81.344 },
      { name: "Lake Helen", lat: 28.981, lng: -81.233 },
      { name: "Orange Camp", lat: 28.994, lng: -81.309 },
    ],
  },
  {
    slug: "daytona-beach",
    name: "Daytona Beach",
    state: "FL",
    region: "Volusia County",
    isPrimary: false,
    lat: 29.2108,
    lng: -81.0228,
    description:
      "Coastal-ready painting and remodeling for Daytona Beach — finishes and materials chosen to stand up to salt air, sun, and humidity.",
    highlights: [
      "Coastal-durable paint systems",
      "Tile & vinyl floor installation",
      "Drywall & remodeling services",
      "Free, no-pressure estimates",
    ],
    content: [
      "Salt air and constant sun are hard on Daytona Beach homes. We select exterior coatings and materials built for coastal conditions, so your paint, floors, and finishes look good longer.",
      "Our Daytona Beach services cover interior and exterior painting, ceramic tile and vinyl plank flooring, drywall repair, bathroom remodeling, cabinet restoration and installation, and drywall repair.",
      "Wherever you are — beachside, downtown, or out toward LPGA — call (786) 306-5704 for a free estimate. New clients receive 10% off.",
    ],
    cities: [
      { name: "Beachside", lat: 29.228, lng: -81.005 },
      { name: "Daytona Beach Shores", lat: 29.176, lng: -80.983 },
      { name: "Holly Hill", lat: 29.243, lng: -81.037 },
      { name: "South Daytona", lat: 29.166, lng: -81.005 },
    ],
  },
  {
    slug: "port-orange",
    name: "Port Orange",
    state: "FL",
    region: "Volusia County",
    isPrimary: false,
    lat: 29.1383,
    lng: -80.9956,
    description:
      "Reliable painting, flooring, and remodeling services for Port Orange families — quality workmanship with honest, upfront pricing.",
    highlights: [
      "Family-home specialists",
      "Painting, flooring & drywall",
      "Bathroom remodeling",
      "10% off for new clients",
    ],
    content: [
      "Port Orange is full of well-kept family neighborhoods, and we help keep them that way. From repainting living spaces and refinishing kitchen cabinets to installing new vinyl plank floors, our crew works clean and communicates clearly from estimate to walkthrough.",
      "Services in Port Orange include interior and exterior painting, tile and vinyl floor installation, drywall repair, bathroom remodeling, cabinet restoration and new installs, plus detailed prep and finish work.",
      "Get a free written estimate for your Port Orange project — and save 10% as a new client.",
    ],
    cities: [
      { name: "Sugar Mill", lat: 29.121, lng: -81.028 },
      { name: "Waters Edge", lat: 29.096, lng: -81.036 },
      { name: "Allandale", lat: 29.166, lng: -80.988 },
      { name: "Harbor Oaks", lat: 29.152, lng: -80.982 },
    ],
  },
  {
    slug: "altamonte-springs",
    name: "Altamonte Springs",
    state: "FL",
    region: "Seminole County",
    isPrimary: false,
    lat: 28.6611,
    lng: -81.3656,
    description:
      "Professional painting, cabinet, and remodeling services for Altamonte Springs homes and condos in the heart of Seminole County.",
    highlights: [
      "Homes, condos & townhomes",
      "Cabinet painting & installs",
      "Interior & exterior painting",
      "Free estimates, clear scope",
    ],
    content: [
      "In Altamonte Springs we work on everything from lakefront homes to condos and townhomes — projects where clean job sites, tidy work, and respect for shared spaces matter.",
      "Our services here include interior and exterior painting, kitchen cabinet restoration and new cabinet installation, tile and vinyl flooring, drywall repair, bathroom remodeling, and the careful finish work that completes a space.",
      "Call (786) 306-5704 for a free estimate anywhere in Altamonte Springs. New clients receive 10% off their first project.",
    ],
    cities: [
      { name: "Uptown Altamonte", lat: 28.663, lng: -81.387 },
      { name: "Spring Oaks", lat: 28.671, lng: -81.402 },
      { name: "Casselberry", lat: 28.678, lng: -81.328 },
      { name: "Longwood", lat: 28.703, lng: -81.338 },
    ],
  },
  {
    slug: "winter-park",
    name: "Winter Park",
    state: "FL",
    region: "Orange County",
    isPrimary: false,
    lat: 28.6,
    lng: -81.3392,
    description:
      "Detail-driven painting, cabinetry, and remodeling for Winter Park — craftsmanship that matches the standards of one of Central Florida's finest communities.",
    highlights: [
      "Premium finish work",
      "Cabinet refinishing specialists",
      "Interior & exterior painting",
      "Careful, clean job sites",
    ],
    content: [
      "Winter Park homes deserve finish work that holds up to a closer look. Our crew delivers sharp paint lines, smooth cabinet finishes, and precise tile work — the details that make quality visible.",
      "In Winter Park we provide interior and exterior painting, cabinet restoration and new cabinet installation, ceramic tile and luxury vinyl flooring, drywall repair, bathroom remodeling, and drywall repair.",
      "Request a free estimate and see the difference disciplined preparation makes. New clients save 10% on their first project.",
    ],
    cities: [
      { name: "Downtown Winter Park", lat: 28.6, lng: -81.351 },
      { name: "Maitland", lat: 28.628, lng: -81.363 },
      { name: "Goldenrod", lat: 28.61, lng: -81.289 },
      { name: "Eatonville", lat: 28.618, lng: -81.381 },
    ],
  },
  {
    slug: "oviedo",
    name: "Oviedo",
    state: "FL",
    region: "Seminole County",
    isPrimary: false,
    lat: 28.67,
    lng: -81.2081,
    description:
      "Painting, flooring, and remodeling services for Oviedo's growing family neighborhoods — quality work, honest service, lasting results.",
    highlights: [
      "Serving Oviedo & Chuluota",
      "Whole-home repaints",
      "Flooring & bathroom remodels",
      "10% new client discount",
    ],
    content: [
      "Oviedo's newer communities and established neighborhoods alike count on us for fresh paint, updated floors, and remodeled bathrooms that add real value.",
      "Our Oviedo services include interior and exterior painting, tile and vinyl plank floor installation, drywall repair and texture matching, kitchen cabinet painting and installation, bathroom remodeling, and detailed finish carpentry and prep work.",
      "Every project starts with a free, no-pressure estimate. Call (786) 306-5704 — new clients receive 10% off.",
    ],
    cities: [
      { name: "Alafaya Woods", lat: 28.648, lng: -81.215 },
      { name: "Twin Rivers", lat: 28.667, lng: -81.169 },
      { name: "Chuluota", lat: 28.642, lng: -81.123 },
      { name: "Winter Springs", lat: 28.699, lng: -81.308 },
    ],
  },
];
